import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import "./index.css";
import App from "./App";

const origin = window.location.origin;

const cognitoAuthConfig = {
  authority:
    process.env.REACT_APP_COGNITO_AUTHORITY ||
    "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_TuYAq7gB3",
  client_id:
    process.env.REACT_APP_COGNITO_CLIENT_ID || "42m0lftgoms9389ju2q04hmboi",
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI || `${origin}/`,
  response_type: "code",
  scope: "phone openid email",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
